import MenuItem from '@mui/material/MenuItem';
import CommandLinkContent from 'core/components/Elements/Command/CommandLinkContent/CommandLinkContent';
import type { ItemComponentProps} from 'core/components/Elements/DropDown/DropDown';
import { menuItemStyles } from 'core/components/Elements/DropDown/DropDown';
import type React from 'react';

function ItemOnClick({
  item, buttonRef, onClose, selected,
}: ItemComponentProps) {
  const {
    id, title, onClick, active,
  } = item;

  return (
    <li role="menuitem" title={title} aria-disabled={active === false}>
      <MenuItem
        component="button"
        role="button"
        data-e2e-dropdown-item={id}
        onClick={(e: React.MouseEvent<HTMLElement>) => {
          onClose(e, buttonRef);
          if (onClick) onClick(item);
        }}
        dense
        disabled={active === false}
        sx={menuItemStyles}
        selected={selected}
      >
        <CommandLinkContent command={item} />
      </MenuItem>
    </li>
  );
}
export default ItemOnClick;
